// extracted by mini-css-extract-plugin
export default {"text":"Tag_text__WlbIl","tag":"Tag_tag__TCU2o"};